import React from 'react';
import { Box, Switch } from '@mui/material';
import { useSectionsFeatureFlag } from 'hooks/useSectionsFeatureFlag';

interface ROneSwitchProps {
    isGeneratingJob: boolean;
}

const ROneSwitch: React.FC<ROneSwitchProps> = ({ isGeneratingJob }) => {
    const { isFeatureEnabled, isSectionsModeEnabled, handleSectionsModeChange } =
        useSectionsFeatureFlag();

    if (!isFeatureEnabled) {
        return <></>;
    }

    return (
        <Box className="sections-mode-content-switch">
            {'R-One'}
            <Switch
                checked={isSectionsModeEnabled}
                onChange={(event) => handleSectionsModeChange(event.target.checked)}
                disabled={isGeneratingJob}
            />
        </Box>
    );
};

export default ROneSwitch;
